import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { authStoreContext } from "../core/mainStore";

export const AuthenticatedView = observer(() => {
  const auth = useContext(authStoreContext);

  useEffect(() => {
    auth.getCurrentUser();
  }, []);

  return <></>;
});
